import Swiper from 'swiper';
import { Keyboard, Navigation } from 'swiper/modules';

import 'swiper/css';

export function homeCarousel() {
  new Swiper('.wp-block-home-carousel .swiper', {
    direction: 'horizontal',
    speed: 500,
    loop: true,
    spaceBetween: 8,
    slidesPerView: 1.1,
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 1.5,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
    on: {
      afterInit: (swiper) => {
        // Play video in initial slide
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          // Rejects when autoplay is blocked or a slide change pauses the
          // video before it has loaded (the slides are preload="none")
          activeVideo.play().catch(() => {});
        }
      },

      slideChangeTransitionStart: (swiper) => {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide.querySelector('video');

        document.querySelectorAll('.swiper-slide video').forEach((video) => {
          if (video === activeVideo) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
    },
    modules: [Navigation, Keyboard],
  });
}
